import * as React from "react";
import { px2Erem, px2Percentage, WEB_GAP } from "../../../utils/edm";
export default class EdmTextArea extends React.PureComponent {
    render() {
        const { content, bgColor = "" } = this.props;
        return (React.createElement("table", { style: {
                width: "100%",
                color: "#333",
                fontSize: "16px",
            } },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { style: { width: `${px2Percentage(WEB_GAP)}` } }),
                    React.createElement("td", { style: {
                            backgroundColor: `${bgColor || "#fff"}`,
                            padding: `0 ${px2Erem(15)}`,
                        }, dangerouslySetInnerHTML: { __html: content } }),
                    React.createElement("td", { style: { width: `${px2Percentage(WEB_GAP)}` } })))));
    }
}
